const Farsi = {
    AboutUs: "درباره آرین",
    AboutUsTitle: "صرافی آرین | درباره ما",
    AddNews: "افزودن خبر جدید",
    AddFile: "افزودن فایل:",
    Address: "تهران، خیابان ملاصدرا، انتهای خیابان شیراز شمالی، ساختمان ایران سکنا، شماره <span>234</span>",
    Admin: "مدیریت",
    AdminA: "زمان ملاقات ها",
    AdminN: "ویرایش اخبار",
    AdminTitle: "صرافی آرین | مدیریت سایت",
    AdminU: "اطلاعات مشتریان",
    AdsArianCoins: "عرضه انواع سکه های بانکی با تفکیک رنگی",
    AdsArianCustomer: "مشتری مداری رمز موفقیت ما و اعتماد شماست",
    AdsArianServices: "صرافی آرین با کادری مجرب درخدمت شماست",
    AdsArianSlang: "اطمینان به ما دلیل همراهی همیشگی شماست",
    AdsCenteralBank: "صرافی آرین با مجوز رسمی از بانک مرکزی ایران",
    AED: "درهم امارات",
    AEDTOM: "درهم امارات",
    Amount:"مقدار ارز",
    Appointment: "زمان ملاقات ها",
    AppointmentBtn: "زمان ملاقات ها",
    Archive: "آرشیو",
    ArianCurrencyRate: "نرخ ارز صرافی آرین",
    ArianDesc: "شرکت تضامنی صرافی ناصر افشار و شرکاء با هدف ارائه مناسب خدمات ارزی، حواله جات و خرید و فروش انواع مسکوکات طلا با مجوز رسمی از بانک مرکزی ایران در سال <span>1388</span> اقدام به راه اندازی شد. قیمت مناسب، ارسال سریع ارز به سراسر دنیا و اطمینان مشتریان از خرید و فروش اهداف اصلی گروه مالی آرین را تشکیل می دهد",
    ArianExchange: "صرافی آرین",
    ArianGoldRate: "نرخ سکه صرافی آرین",
    Ask: "فروش",
    AskToDel: "آیا می خواهید این خبر را حذف کنید: ",
    AUD: "دلار استرالیا",
    AUDTOM: "دلار استرالیا",
    AZADITOM: "سکه آزادی",
    BCHUSD: "بیت کش / دلار",
    Bid: "خرید",
    BTCUSD: "بیت کوین / دلار",
    CAD: "دلار کانادا",
    CADTOM: "دلار کانادا",
    Clear: "پاک",
    Cancel: "لغو فرآیند",
    ChangeFile: "تغییر فایل: ",
    Changes: "تغییرات",
    ChoosePass: "انتخاب رمز ورود",
    Confirmation: "تایید مجدد رمز",
    ConfirmToDel: "حذف شود",
    ConfirmToEdit: "بروزرسانی شود",
    ContactUs: "تماس با ما",
    Content: "متن فارسی خبر",
    ContentEn: "متن انگلیسی خبر",
    ConvertorCaption: "<cta>{remain}</cta>",
    ConvertorResult: "<cta>{amount}</cta><b>=</b><p>{result}</p>",
    CopyRight: "تمام حقوق مادی و معنوی این وبسایت متعلق به صرافی آرین است",
    Currency: "نوع ارز",
    CurrencyConvertor: "تبدیل گر نرخ آرین",
    CryptoUnit: "واحد نرخ هر ارز دیجیتالی به دلار می باشد",
    DefaultSelect: "نوع خبر را انتخاب کنید...",
    Delete: "حذف",
    Edit: "ویرایش",
    Email: "ایمیل",
    EMA: "تمام سکه امامی",
    EMAMITOM: "سکه امامی",
    EREL: "فقط حروف انگلیسی اعداد و علامت های ! ؟ % $ . : () \" ' و ، را وارد کنید",
    EREM: "فیلد مورد نیاز / آدرس ایمیل صحیح نمی باشد",
    EREX: "قبلا با این ایمیل ثبت نام شده است",
    ERFE: "فایلی را انتخاب نکرده اید!",
    ERFF: "فایل هایی با پسوند jpg, gif, png, svg, tiff, mp4 قابل قبول هستند",
    ERFN: "فیلد مورد نیاز / فقط حروف انگلیسی یا فارسی قابل قبول می باشد",
    ERFL: "فقط حروف فارسی، اعداد و علامت های - ! ؟ . : () \" و ، را وارد کنید",
    ERGE: "پر کردن تمامی فیلدها بجز متن خبر ضروری می باشد",
    ERGR: "پر کردن تمامی فیلدها ضروری می باشد",
    ERNA: "دسترسی شما تایید نشده است",
    ERNR: "عضویت شما مورد تایید نمی باشد، لطفا ثبت نام نمایید",
    ERPA: "فیلد مورد نیاز /  8 تا 16 حرف انگلیسی شامل حداقل یک حرف کوچک، یک حرف بزرگ و یک عدد",
    ERPC: "رمزعبور با رمز تایید مجدد مطابقت ندارند",
    ERPH: "فیلد مورد نیاز / شماره موبایل باید بین 10 تا 13 رقم باشد",
    ERWR: "مشکل فنی، لطفا دوباره سعی نمایید",
    ERWEP: "ایمیل یا پسورد خود را اشتباه وارد کرده اید",
    ETHUSD: "اتریوم / دلار",
    EUR: "یورو",
    EURTOM: "یورو",
    Fax: "57967 880 (21 98+)",
    FirstName: "نام",
    ForeignUnit: "نرخ برابری برای هر دلار آمریکا می باشد",
    GBP: "پوند انگلیس",
    GBPTOM: "پوند انگلیس",
    GRAMTOM: "سکه گرمی",
    Home: "خانه",
    HomeTitle: "صرافی آرین | نرخ ارز، سکه و حوالجات",
    HALFTOM: "سکه نیم",
    LastName: "نام خانوادگی",
    LastNews: "آخرین خبر",
    LastPrice: "نرخ",
    Live: "لحظه ای",
    LiveCryptoRate: "نرخ جهانی ارز دیجیتال",
    LiveForeignRate: "نرخ جهانی ارز",
    LiveGoldRate: "نرخ جهانی طلا",
    Login: "ورود اعضا",
    LoginTitle: "صرافی آرین | ورود",
    Logout: "خروج",
    LTCUSD: "لایت کوین / دلار",
    Mobile: "موبایل",
    MoreInfo: "بیشتر بدانید...",
    News: "اخبار مالی",
    NewAccount: "عضویت جدید",
    NewsArchive: "آرشیو خبر",
    Newsarticle: "متن ",
    NewsBtn: "ویرایش اخبار",
    Newsposter: "پوستر",
    NewsTitle: "صرافی آرین | اخبار مالی",
    Newsvideo: "ویدیو",
    NIM: "نیم بهار آزادی ",
    NotFoundTitle: "متاسفیم، صفحه مورد نظر شما در دسترس نمی باشد",
    OUNCEUSD: "اونس / دلار",
    OunceUnit: "واحد نرخ هر اونس (انس) به دلار می باشد",
    OurTeam: "همکاران ما",
    OurTeamDesc: "مفتخریم که در این سالها همواره با پرسنلی توانمند و دلسوز همراه و همکار بوده ایم. قدردانیم و می دانیم که نبود هریک از این عزیزان رسیدن به جایگاه فعلی این صرافی را سخت تر می کرد. اطمینان داریم که تک تک همکاران ما سعی داشته و دارند که بهترین خدمات را در چارچوب قوانین و مقررات خواسته شده به شما ارائه دهند. امید داریم با بهره مندی از نیرویی جوان، مستعد و متخصص همواره در ارائه خدمات نو و کارآمد برای شما مشتریان گرامی پیشگام باشیم.",
    Pass: "رمز ورود",
    Phone: "59201 880 (21 98+)",
    Product: "نوع کالا",
    Quarterly: "هر 15 دقیقه",
    QUARTERTOM: "سکه ربع",
    ROB:  "ربع بهار آزادی",
    Save: "ذخیره",
    SignIn: "ورود", 
    SignupTitle: "صرافی آرین | عضویت",
    Submit: "ثبت نام",
    SuccessReg: "ثبت نام شما با موفقیت انجام شد",
    SUMG: "فرآیند مورد نظر با موفقیت انجام شد",
    TableContent: "محتوا",
    TableOperations: "عملیات",
    TableTitle: "عنوان",
    TableUpdate: "آخرین بروزرسانی",
    Title: "عنوان فارسی خبر",
    TitleEn: "عنوان انگلیسی خبر",
    TMA: "تمام بهار آزادی",
    TOMAN: "تومان",
    TomanUnit: "واحد نرخ ها به تومان می باشد",
    TRY: "لیر ترکیه",
    TRYTOM: "لیر ترکیه",
    UpdateNews: "بروزرسانی اخبار",
    USD: "دلار آمریکا",
    USDAUD: "دلار / دلار استرالیا",
    USDCAD: "دلار / دلار کانادا",
    USDCNY: "دلار / یوان چین",
    USDEUR: "دلار / یورو",
    USDGBP: "دلار / پوند انگلیس",
    USDIQD: "دلار / دینار عراق",
    USDMYR: "دلار / رینگت مالزی",
    USDTHB: "دلار / بات تایلند",
    USDTOM: "دلار",
    USDTRY: "دلار / لیر ترکیه",
    UNDERTOM: "سکه زیر 86",
    UserInfoBtn: "اطلاعات مشتریان",
    Warning: "این فیلم را مرورگر شما پشتیبانی نمی کند",
    WorkTime: "شنبه تا چهارشنبه <span>9:30 الی 16:30</span>",
    WorkTimeEx:"پنج شنبه <span>9:30 الی 13:30</span>",
    XAUUSD: "اونس طلا / دلار",
    XAGUSD: "اونس نقره / دلار",
    XRPUSD: "ریپل / دلار",
    YEK: "سکه یک گرمی"
}

export default Farsi;